<template>
  <router-view />
  <ConfirmDialog
    :open="confirmState.open"
    :title="confirmState.title"
    :message="confirmState.message"
    :confirm-text="confirmState.confirmText"
    :tone="confirmState.tone"
    :icon="confirmState.icon"
    @confirm="confirm"
    @cancel="cancel"
  />
</template>

<script>
import ConfirmDialog from "@/modules/shared/components/ConfirmDialog";
import useConfirm from "@/modules/shared/composables/useConfirm";
export default {
  components: { ConfirmDialog },
  setup() {
    const { confirmState, confirm, cancel } = useConfirm();
    return { confirmState, confirm, cancel };
  },
};
</script>
